export default __webpack_public_path__ + "static/media/logo.27f75358.png";